import { ActionTree, Commit } from 'vuex';
import { IState } from './state';
import config from '@/params/config';
import * as TYPES from './types';
import { apiFetchAction } from '../apiUtil';

// const apiRoot: string = `${config.neo}/${config.apiVersion}`;
const apiRoot: string = config.neo;

interface IActionContent {
  state: IState;
  commit: Commit;
}

// 查询课程类型
const getCourseTypes = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'peiban/GetCourseCategory',
    'GET',
    TYPES.COURSE_TYPES,
    payload,
    false,
    apiRoot
  );
};

// 查询课程
const getCourseCategory = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'peiban/SearchCourseInfo',
    'GET',
    TYPES.COURSE_CATEGORY,
    payload,
    false,
    apiRoot
  );
};

// 查询课程详情
const getCourseInfo = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'peiban/GetCourseInfoById',
    'GET',
    TYPES.COURSE_INFO,
    payload,
    false,
    apiRoot
  );
};

// 查询课程评分
const getCourseScore = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'peiban/GetCourseSocre',
    'GET',
    TYPES.COURSE_SCORE,
    payload,
    false,
    apiRoot
  );
};

// 课程打分
const setCourseScore = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'peiban/GradeCourse',
    'POST',
    TYPES.COURSE_SCORE_SET,
    payload,
    false,
    apiRoot
  );
};

// 课程已看
const setCoursePlayed = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'peiban/AddCoursePlayCount',
    'POST',
    TYPES.COURSE_PLAYED,
    payload,
    false,
    apiRoot
  );
};

// 提交反馈
const setCourseFeedback = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'peiban/AddCourseFeedback',
    'POST',
    TYPES.COURSE_FEEDBACK,
    payload,
    false,
    apiRoot
  );
};

export const actions = {
  getCourseTypes,
  getCourseCategory,
  getCourseInfo,
  getCourseScore,
  setCourseScore,
  setCoursePlayed,
  setCourseFeedback
};
